// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1rWie","overflowing":"ReadFullNote_overflowing__3Eh0d"};